import { gql } from '@apollo/client';

export const UserQuery = gql`
  query UserPool($email: String!) {
    userPool(email: $email) {
      region
      userPoolId
      clientId
      cognitoHostedDomain
      identityProviders
      signUpEnabled
    }
  }
`;
